import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { useIntl } from 'react-intl';

import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

type Props = {
  onBack: () => void;
};

export const BackButton = ({ onBack }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <IconButton
      size="medium"
      onClick={onBack}
      icon={faChevronLeft}
      color="tertiary"
      aria-label={formatMessage(glossary.back)}
    />
  );
};
